/**
 * Field-type registry — a new component type is added here once and every
 * consumer (renderer now, builder/preview later) picks it up automatically.
 * Never add a new `if (type === '...')` branch elsewhere; extend this map.
 */
export const FIELD_TYPES = {
  text: { label: 'Single Line Text', category: 'basic', inputType: 'text' },
  textarea: { label: 'Long Text', category: 'basic' },
  email: { label: 'Email', category: 'basic', inputType: 'email' },
  phone: { label: 'Phone', category: 'basic', inputType: 'tel' },
  number: { label: 'Number', category: 'basic', inputType: 'number' },
  url: { label: 'URL', category: 'basic', inputType: 'url' },
  select: { label: 'Dropdown', category: 'choice' },
  radio: { label: 'Radio', category: 'choice' },
  checkbox: { label: 'Checkbox', category: 'choice' },
  checkboxGroup: { label: 'Checkbox Group', category: 'choice' },
  date: { label: 'Date', category: 'datetime', inputType: 'date' },
  time: { label: 'Time', category: 'datetime', inputType: 'time' },
  datetime: { label: 'Date & Time', category: 'datetime', inputType: 'datetime-local' },
  rating: { label: 'Rating', category: 'choice' },
  file: { label: 'File Upload', category: 'basic' },
  signature: { label: 'Signature', category: 'basic' },
  hidden: { label: 'Hidden Field', category: 'layout' },
  heading: { label: 'Heading', category: 'layout', display: true },
  paragraph: { label: 'Paragraph', category: 'layout', display: true },
};

/** Field types whose validation rules (min/max length, pattern) make sense to expose in the builder. */
export const VALIDATABLE_TEXT_TYPES = new Set(['text', 'textarea', 'email', 'phone', 'url']);
export const VALIDATABLE_NUMBER_TYPES = new Set(['number']);

export function isKnownType(type) {
  return Object.prototype.hasOwnProperty.call(FIELD_TYPES, type);
}
